import React, { useRef } from 'react';
import { Button, Card } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import './FirmaCanvas.css';

/**
 * Componente reutilizable para captura de firma digital
 * @param {Function} onSave - Callback que recibe la firma como base64 data URL
 * @param {string} label - Texto descriptivo para el área de firma
 */
const FirmaCanvas = ({ onSave, label = 'Firme en el recuadro' }) => {
  const sigCanvas = useRef(null);

  const handleClear = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };

  const handleSave = () => {
    if (sigCanvas.current) {
      // Verificar que no esté vacío
      if (sigCanvas.current.isEmpty()) {
        alert('Por favor firme en el recuadro antes de guardar');
        return;
      }

      // Obtener firma como base64 data URL
      const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
      
      if (onSave) {
        onSave(dataURL);
      }
    }
  };

  return (
    <Card className="firma-canvas-card w-100">
      <Card.Body className="w-100">
        <Card.Title className="mb-3 w-100">
          <i className="bi bi-pen me-2"></i>
          {label}
        </Card.Title>
        
        <div className="firma-canvas-wrapper">
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{
              className: 'firma-canvas',
              width: 500,
              height: 200
            }}
          />
        </div>

        <div className="d-flex gap-2 mt-3 w-100">
          <Button 
            variant="outline-secondary" 
            onClick={handleClear}
            className="d-flex align-items-center justify-content-center w-100"
          >
            <i className="bi bi-x-circle me-2"></i>
            Limpiar
          </Button>
          
          <Button 
            variant="primary" 
            onClick={handleSave}
            className="d-flex align-items-center justify-content-center w-100"
          >
            <i className="bi bi-check-circle me-2"></i>
            Confirmar Firma
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default FirmaCanvas;
